module.exports = __webpack_public_path__ + "img/img_jnmy_brand@3x.3baa729d.png";